import Header from "../components/Header";

export const ConfirmedBookingPage = () => {
  return (
    <>
      <Header />
      <div className="text-center mt-[250px]">
        <p className="text-4xl ">Booking Successful ✅</p>
      </div>
    </>
  );
};
